/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

export class Timer {
  timerId: number;
  start: number;
  remaining: number;
  callback: () => void;
  constructor(callback: () => void, delay: number) {
    this.remaining = delay;
    this.callback = callback;
    this.timerId = 0;
    this.start = 0;
    this.resume();
  }
  public pause = () => {
    window.clearTimeout(this.timerId);
    this.remaining -= Date.now() - this.start;
  };

  public resume = () => {
    this.start = Date.now();
    window.clearTimeout(this.timerId);
    this.timerId = window.setTimeout(this.callback, this.remaining);
  };
}
